import { create } from 'zustand';
import { DemoInfo } from '../types/DemoInfo';

interface DemoInfoStore {
  demoInfo: DemoInfo | null;
  setDemoInfo: (info: DemoInfo) => void;
  blockDemo: () => void;
  unblockDemo: () => void;
  toggleDemo: (status: boolean) => void;
}

export const useDemoInfoStore = create<DemoInfoStore>((set, get) => ({
  demoInfo: null,
  setDemoInfo: (info: DemoInfo) => set({ demoInfo: info }),
  blockDemo: () => {
    const currentDemoInfo = get().demoInfo;
    if (currentDemoInfo) {
      set({
        demoInfo: currentDemoInfo.copyWith({ isUserAllowed: false }),
      });
    }
  },
  unblockDemo: () => {
    const currentDemoInfo = get().demoInfo;
    if (currentDemoInfo) {
      set({
        demoInfo: currentDemoInfo.copyWith({ isUserAllowed: true }),
      });
    }
  },
  toggleDemo: (status: boolean) => {
    const currentDemoInfo = get().demoInfo;
    if (currentDemoInfo) {
      set({
        demoInfo: currentDemoInfo.copyWith({ isUserAllowed: status }),
      });
    }
  },
}));
